import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Navigation from "../../edsider/components/Navigation"
import Hero from "../../edsider/components/Hero"
import Support from "../../edsider/components/Support"
import GetStarted from "../../edsider/components/GetStarted"
import About from "../../edsider/components/About"
import ChooseEdsider from "../../edsider/components/ChooseEdsider"
import Tabs from "../../edsider/components/Tabs"
import Scholarships from "../../edsider/components/Scholarships"
import Footer from "../../edsider/components/Footer"
import "../../edsider/assets/css/edsider-landing.css"
import { routes } from "../../../helper/routes"

class StudentParentLandingPage extends Component {
  handleRoleSelect = (role) => {
    sessionStorage.setItem("user_role_selection", role)
    this.props.history.push(routes.auth_response)
  }


  render() {
    return (
      <>
        <div className="bg-landing-page">
          <Navigation />
          <Hero />
          {/* <Carousal /> */}
          <Support />
          <div className="light-blue-container">
            <GetStarted />
          </div>
          <div className="bg-about-section">
            <About />
          </div>
          <div className="light-blue-container">
            <ChooseEdsider />
          </div>
          <Tabs />
          {/* <div className="light-blue-container">
            <Papers />
          </div> */}
          <div className="bg-scholarship-section">
            <Scholarships />
          </div>
          {/* <div className="light-blue-container">
            <Testimonials />
          </div> */}
          <Footer />
        </div>
        {/* <div className='landing-bg'>
          <div className='container pb-5'>
            <div className='row py-5'>
              <img className='logo-img' src={logo} alt='Logo' />
            </div>
            <div className='row pt-4 d-flex justify-content-center'>
              <center>
                <h1 className='landing-topic'>JOIN WITH US</h1>
                <p className='landing-para mt-5'>Online Exams From Wherever You Are</p>
              </center>
            </div>
            <div className='d-flex justify-content-center'>
              <div className='col-lg-4 col-sm-6 col-xs-12'>
                <center>
                  <div className='card landing-card mt-3 '>
                    <img className='card-img-top' src={student} alt='student-img' />
                    <div className='card-body'>
                      <center>
                        <button
                          type='button'
                          className='btn btn-outline-dark landing-btn my-2'
                          onClick={() => this.handleRoleSelect('student')}
                        >
                          LOGIN
                        </button>
                        <button
                          type='button'
                          
                          className='btn btn-outline-dark landing-btn my-2'
                          onClick={this.handleSignUp}
                        >
                          SIGN UP
                        </button>
                      </center>
                    </div>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div> */}
      </>
    )
  }
}

export default withRouter(StudentParentLandingPage)
